import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { ApplicationSteps, MembershipSummary } from 'member-portal/components'
import { selectors } from '../reducer'
import { selectors as memberSelectors } from 'member-reducer'
import { GIFT_APPLICATION_STEP_LINKS, PATH, makeGiftPath } from 'config'
import { ProductPrices, DigitalRecipientType } from 'types'

const propTypes = {
  billingContact: PropTypes.object,
  children: PropTypes.node.isRequired,
  giftMessage: PropTypes.string,
  membershipPrices: ProductPrices.isRequired,
  recipientContact: DigitalRecipientType,
  selectedMembershipType: PropTypes.string.isRequired,
}

function GiftStepsLayout({
  billingContact,
  children,
  giftMessage,
  membershipPrices,
  recipientContact,
  selectedMembershipType,
}) {
  const { pathname } = useLocation()

  return (
    <>
      <div className="form-with-aside-wrapper">
        <header className="header-title">
          <h1>Gift Membership</h1>
        </header>
        <div className="form-with-aside-block">
          <div className="form-with-aside">
            <ApplicationSteps
              billingContact={billingContact}
              giftMessage={giftMessage}
              pathname={pathname}
              recipientContact={recipientContact}
              stepLinks={GIFT_APPLICATION_STEP_LINKS}
            >
              {children}
            </ApplicationSteps>
          </div>
          <aside>
            <MembershipSummary
              membershipPrices={membershipPrices}
              membershipType={selectedMembershipType}
              updateLink={makeGiftPath(PATH.ROOT)}
            />
          </aside>
        </div>
      </div>
    </>
  )
}

GiftStepsLayout.propTypes = propTypes

function mapStateToProps(state) {
  return {
    billingContact: selectors.billingContact(state),
    giftMessage: selectors.giftMessage(state),
    membershipPrices: memberSelectors.membershipPrices(state),
    recipientContact: selectors.recipientContact(state),
    selectedMembershipType: selectors.selectedMembershipType(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  GiftStepsLayout
)
